import React, { forwardRef } from 'react';
interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}
export const TextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>(({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}, ref) => {
  const textareaId = id || label?.toLowerCase().replace(/\s+/g, '-');
  return <div className="w-full" data-id="element-365">
        {label && <label htmlFor={textareaId} className="block text-sm font-medium text-gray-700 mb-1" data-id="element-366">
            {label}
          </label>}
        <textarea ref={ref} id={textareaId} className={`
            w-full px-3 py-2 border rounded-lg text-gray-900
            placeholder:text-gray-400
            focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent
            disabled:bg-gray-50 disabled:text-gray-500 disabled:cursor-not-allowed
            resize-y min-h-[80px]
            ${error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'}
            ${className}
          `} aria-invalid={error ? 'true' : 'false'} aria-describedby={error ? `${textareaId}-error` : helperText ? `${textareaId}-helper` : undefined} {...props} data-id="element-367" />
        {error && <p id={`${textareaId}-error`} className="mt-1 text-sm text-red-600" data-id="element-368">
            {error}
          </p>}
        {helperText && !error && <p id={`${textareaId}-helper`} className="mt-1 text-sm text-gray-500" data-id="element-369">
            {helperText}
          </p>}
      </div>;
});
TextArea.displayName = 'TextArea';